import { T, useTheme, dens, Ico, Card, Eyebrow, Btn, StatusBadge } from '../../../design';
import type { EnrollmentWithCourse } from '../../../types/courses.types';
import { fmtDate, fmtPrice } from '../../../utils';
import { parseLocalDate } from '../../../utils/date';
import { EmptyState } from './states';

function isPast(courseDate: string): boolean {
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  return parseLocalDate(courseDate) < today;
}

export interface MyEnrollmentsProps {
  enrollments: EnrollmentWithCourse[];
  onCancel: (enrollment: EnrollmentWithCourse) => void;
}

export function MyEnrollments({ enrollments, onCancel }: MyEnrollmentsProps) {
  const t = useTheme();
  const d = dens(t);
  if (enrollments.length === 0) return <EmptyState icon="book" title="Ingen tilmeldinger" sub="Du er ikke tilmeldt nogen kurser endnu. Find et kursus under Kurser." />;
  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: d.gap }}>
      <Eyebrow>Mine tilmeldinger · {enrollments.length}</Eyebrow>
      {enrollments.map((en) => {
        const cancellable = (en.status === 'approved' || en.status === 'pending') && !isPast(en.courseDate);
        return (
          <Card key={en.id} pad={14}>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
              <StatusBadge status={en.status} />
              <span style={{ fontSize: 13, fontWeight: 800, color: t.accent }}>{fmtPrice(en.coursePrice)}</span>
            </div>
            <div style={{ fontSize: 15, fontWeight: 800, color: T.fg }}>{en.courseProductName}</div>
            <div style={{ fontSize: 12, color: T.fg3, fontWeight: 600, marginTop: 4, display: 'flex', gap: 10, flexWrap: 'wrap' }}>
              <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><Ico.clock size={13} />{fmtDate(en.courseDate)}</span>
              <span style={{ display: 'flex', alignItems: 'center', gap: 4 }}><Ico.store size={13} />{en.courseLocation || 'Oplyses senere'}</span>
            </div>
            {cancellable && <Btn variant="secondary" size="sm" onClick={() => onCancel(en)} style={{ marginTop: 12, color: T.error, borderColor: T.errorBorder }}>Afmeld</Btn>}
            {en.status === 'awaiting_credit' && <div style={{ marginTop: 10, fontSize: 11.5, color: T.info, fontWeight: 600, display: 'flex', gap: 6, alignItems: 'center' }}><Ico.info size={14} />Afventer kreditnota fra økonomi</div>}
          </Card>
        );
      })}
    </div>
  );
}
